import * as v from "valibot";

export const vEmptyToUndefined = v.transform((value: string) =>
  value === "" ? undefined : value,
);

export const vDateFormatOptions = () =>
  v.object({
    date_fmt: v.optional(v.pipe(v.string(), vEmptyToUndefined)),
    timestamp_fmt: v.optional(v.pipe(v.string(), vEmptyToUndefined)),
  });
